<template>
  <div class="overlay-full overlay-check-status" :class="{'d-block': showOverlay}">
    <div v-if="!loadingActivity" class="overlay-content">
      <p class="title">Are you still in {{ currentActivity.label }}</p>
      <p>To continue working please answer</p>
        <custom-button
          variant="primary"
          custom-class="check-status-button"
          content="Yes"
          @onClick="setActivity(currentActivity.status)"
        />
        <custom-button
          variant="light"
          custom-class="check-status-button"
          content="No"
          @onClick="setActivity('online')"
        />
    </div>
    <div v-else class="overlay-content">
      <p class="title">Updating your activity status..</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { eventBus } from "../../utils/helpers";
import CustomButton from "../Button.vue";

export default {
  name: "OverlayCheckStatus",
  components: {
    CustomButton
  },
  data() {
    return {
      isLoading: false,
      showOverlay: false
    };
  },
  mounted() {
    eventBus.$on('show-check-status-overlay', this.overlayEventHandler);
  },
  destroyed() {
    eventBus.$off('show-check-status-overlay', this.overlayEventHandler);
  },
  computed: {
    ...mapState("activity", ["loadingActivity"]),
    ...mapGetters("activity", ["currentActivity"])
  },
  methods: {
    ...mapActions("activity", ["setCurrentActivity"]),

    setActivity(activity) {
      this.setCurrentActivity([activity])
      this.showOverlay = false
    },
    overlayEventHandler() {
      this.showOverlay = this.currentActivity.status !== 'online';
    }
  }
};
</script>
